import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '初期費用はかかりますか？',
      answer:
        '初期費用は一切不要です。月額料金のみでご利用いただけます。ただし、リスティング用の写真撮影や備品購入が必要な場合は、別途実費をご負担いただく場合がございます。',
    },
    {
      question: '契約期間の縛りはありますか？',
      answer:
        '最低契約期間は3ヶ月です。それ以降はいつでも解約可能で、解約金も発生しません。また、プラン変更もいつでも可能です。',
    },
    {
      question: '清掃はどのように手配されますか？',
      answer:
        '弊社が提携する清掃業者を手配いたします。清掃費用は別途実費（1回あたり5,000円〜）となります。清掃のタイミングや品質管理もすべて弊社が行います。',
    },
    {
      question: 'トラブルが発生した場合はどうなりますか？',
      answer:
        'スタンダードプラン以上では24時間対応のトラブルサポートをご提供しています。騒音クレーム、設備故障、ゲストとのトラブルなど、あらゆる問題に迅速に対応いたします。',
    },
    {
      question: '収益はどのくらい見込めますか？',
      answer:
        '物件の立地・広さ・設備により異なりますが、都内1Kマンションで月15〜25万円程度の売上が平均的です。無料相談時に、お客様の物件に応じた収益シミュレーションをご提示いたします。',
    },
    {
      question: '遠方の物件でも対応可能ですか？',
      answer:
        '現在は東京都内を中心に対応しております。神奈川・千葉・埼玉の一部エリアも対応可能ですので、まずはお気軽にご相談ください。',
    },
  ];

  return (
    <section className="py-24 relative overflow-hidden">
      {/* 和紙風背景 */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-50 via-stone-50 to-amber-50" />
      
      {/* 上部装飾ライン */}
      <div className="absolute top-0 left-0 right-0 h-3 bg-gradient-to-r from-transparent via-[#8b2500] to-transparent opacity-60" />
      <div className="absolute top-3 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent" />
      
      {/* 市松模様装飾 */}
      <div className="absolute top-8 left-0 right-0 flex justify-center gap-1">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className={`w-3 h-3 ${i % 2 === 0 ? 'bg-[#8b2500]' : 'bg-[#c9a84c]'} opacity-40`}
          />
        ))}
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            <span className="text-[#8b2500]">◆</span> よくあるご質問 <span className="text-[#8b2500]">◆</span>
          </h2>
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-[#c9a84c]" />
            <span className="text-[#c9a84c] text-sm" style={{ fontFamily: "'Noto Serif JP', serif" }}>✦</span>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-[#c9a84c]" />
          </div>
          <p className="text-lg text-slate-600" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            お客様からよくいただくご質問をまとめました
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-white border-2 border-[#8b2500]/30 rounded-xl overflow-hidden hover:border-[#8b2500] transition-all hover:shadow-lg relative"
            >
              {/* 四隅装飾 */}
              <div className="absolute top-0 left-0 w-3 h-3 border-t-2 border-l-2 border-[#c9a84c]" />
              <div className="absolute top-0 right-0 w-3 h-3 border-t-2 border-r-2 border-[#c9a84c]" />
              <div className="absolute bottom-0 left-0 w-3 h-3 border-b-2 border-l-2 border-[#c9a84c]" />
              <div className="absolute bottom-0 right-0 w-3 h-3 border-b-2 border-r-2 border-[#c9a84c]" />

              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-start gap-4 p-6 text-left cursor-pointer hover:bg-amber-50/50 transition-colors"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#8b2500] to-[#a52a00] rounded-lg flex-shrink-0 shadow-md">
                  <span className="text-white font-bold text-lg" style={{ fontFamily: "'Noto Serif JP', serif" }}>Q</span>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-slate-900 mb-1" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                    {faq.question}
                  </h3>
                </div>
                <div className={`w-8 h-8 flex items-center justify-center text-[#8b2500] transition-transform flex-shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-2xl"></i>
                </div>
              </button>

              {openIndex === idx && (
                <div className="px-6 pb-6 border-t-2 border-[#c9a84c]/30">
                  <div className="flex items-start gap-4 pt-6">
                    <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#c9a84c] to-[#d4af37] rounded-lg flex-shrink-0 shadow-md">
                      <span className="text-white font-bold text-lg" style={{ fontFamily: "'Noto Serif JP', serif" }}>A</span>
                    </div>
                    <p className="flex-1 text-slate-700 leading-relaxed" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center bg-white border-2 border-[#8b2500] rounded-2xl p-8 shadow-lg relative">
          {/* 四隅装飾 */}
          <div className="absolute top-0 left-0 w-6 h-6 border-t-4 border-l-4 border-[#c9a84c]" />
          <div className="absolute top-0 right-0 w-6 h-6 border-t-4 border-r-4 border-[#c9a84c]" />
          <div className="absolute bottom-0 left-0 w-6 h-6 border-b-4 border-l-4 border-[#c9a84c]" />
          <div className="absolute bottom-0 right-0 w-6 h-6 border-b-4 border-r-4 border-[#c9a84c]" />

          <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#8b2500] to-[#a52a00] rounded-full mx-auto mb-4 shadow-lg">
            <i className="ri-question-answer-line text-white text-2xl"></i>
          </div>
          <h3 className="text-xl font-bold text-slate-900 mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            その他のご質問はお気軽に
          </h3>
          <p className="text-slate-600 mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            ご不明な点がございましたら、無料相談にてお答えいたします
          </p>
          <div className="h-px bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent mb-4" />
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#8b2500] via-[#a52a00] to-[#8b2500] hover:from-[#a52a00] hover:via-[#8b2500] hover:to-[#a52a00] text-white font-bold px-8 py-3 rounded-lg transition-all hover:shadow-xl hover:-translate-y-0.5 whitespace-nowrap cursor-pointer shadow-lg"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            <span className="text-[#c9a84c]">✦</span>
            無料相談を申し込む
            <i className="ri-arrow-right-line"></i>
          </a>
          <div className="h-px bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent mt-4" />
        </div>
      </div>

      {/* 下部装飾ライン */}
      <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-1">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className={`w-3 h-3 ${i % 2 === 0 ? 'bg-[#8b2500]' : 'bg-[#c9a84c]'} opacity-40`}
          />
        ))}
      </div>
      <div className="absolute bottom-4 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-3 bg-gradient-to-r from-transparent via-[#8b2500] to-transparent opacity-60" />
    </section>
  );
}